module.exports = __webpack_public_path__ + "static/media/fastBackground.577f56a4.mp3";